module.exports = __webpack_public_path__ + "static/media/home_bg@2x.12020994.png";